import {
  TripAutomatedMessageNumber,
  TripDetailsForTripEditFormQuery,
} from '@website/types/graphqlOperations';
import PreDepartureAutomatedMessageForm from './PreDepartureAutomatedMessageForm';

type Props = {
  tripID: string;
  automatedMessages?: TripDetailsForTripEditFormQuery['tripByURL']['automatedMessages'];
};

export default function PreDepartureAutomatedMessage({
  tripID,
  automatedMessages,
}: Props) {
  return (
    <>
      <h3>Send two messages to guests a few weeks before Trip Departure.</h3>

      <PreDepartureAutomatedMessageForm
        tripID={tripID}
        automatedMessage={automatedMessages.find(
          (message) => message.messageNumber === TripAutomatedMessageNumber.ONE,
        )}
        messageNumber={TripAutomatedMessageNumber.ONE}
      />

      <PreDepartureAutomatedMessageForm
        tripID={tripID}
        automatedMessage={automatedMessages.find(
          (message) => message.messageNumber === TripAutomatedMessageNumber.TWO,
        )}
        messageNumber={TripAutomatedMessageNumber.TWO}
      />

      <h3>Send message after the trip </h3>

      <PreDepartureAutomatedMessageForm
        tripID={tripID}
        automatedMessage={automatedMessages.find(
          (message) =>
            message.messageNumber === TripAutomatedMessageNumber.POST_TRIP,
        )}
        messageNumber={TripAutomatedMessageNumber.POST_TRIP}
      />
    </>
  );
}
